export default __webpack_public_path__ + "static/media/packed.2088e701.svg";